export const isPhone = (str: string) => new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/i).test(str)

export const isEmail = (str: string) =>
  new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
  ).test(str)

// At least 6 char long, at least 1 number and at least 1 letter
export const isPasswordStrongEnough = (str: string) => str.length > 5 && /\d/.test(str) && /[a-zA-Z]/.test(str)
